import { changeDpiBlob } from 'changedpi';

var JSZip = require("jszip");
var FileSaver = require('file-saver');
var async = require("async");
var zip = new JSZip();

let trimmedHeight;
let trimmedWidth;

export default class ImageProcessor {

	static trimCanvasFromSrc(src, callback) {
		const realImage = new Image();
		realImage.onload = () => {
			const canvas = ImageProcessor.trimCanvas(realImage);
			callback(canvas.toDataURL())
		};
		realImage.src = src;
	}

	static trimCanvas(image) {
		let c = document.createElement('canvas');
		c.width = image.width;
		c.height = image.height;

		let ctx = c.getContext('2d');
		ctx.drawImage(image, 0, 0, image.width, image.height);

		let copy = document.createElement('canvas').getContext('2d'),
			pixels = ctx.getImageData(0, 0, c.width, c.height),
			l = pixels.data.length,
			i,
			bound = {
				top: null,
				left: null,
				right: null,
				bottom: null
			},
			x, y;

		// Iterate over every pixel to find the highest
		// and where it ends on every axis ()
		for (i = 0; i < l; i += 4) {
			if (pixels.data[i + 3] !== 0) {
				x = (i / 4) % c.width;
				y = ~~((i / 4) / c.width);

				if (bound.top === null) {
					bound.top = y;
				}

				if (bound.left === null) {
					bound.left = x;
				} else if (x < bound.left) {
					bound.left = x;
				}

				if (bound.right === null) {
					bound.right = x;
				} else if (bound.right < x) {
					bound.right = x;
				}

				if (bound.bottom === null) {
					bound.bottom = y;
				} else if (bound.bottom < y) {
					bound.bottom = y;
				}
			}
		}

		// Calculate the height and width of the content
		let trimHeight = bound.bottom - bound.top,
			trimWidth = bound.right - bound.left,
			trimmed = ctx.getImageData(bound.left, bound.top, trimWidth, trimHeight);

		trimmedHeight = trimHeight;
		trimmedWidth = trimWidth;
		copy.canvas.width = trimWidth;
		copy.canvas.height = trimHeight;
		copy.putImageData(trimmed, 0, 0);

		// Return trimmed canvas
		return copy.canvas;
	}

	static createBlob(canvas, cb) {
		canvas.toBlob(function(blob){
			changeDpiBlob(blob, 300)
			.then(function(b){
				cb(b);
			})
		}, 'image/png')
	}

	static download(name, canvas) {
		const link = document.createElement('a');
		link.download = name;
		ImageProcessor.createBlob(canvas, function(blob){
			link.href = URL.createObjectURL(blob);
			link.click();
		})
	}

	static downloadAll(files, cb) {
		let count = 0;
		let processed = [];
		async.eachLimit(files, 1, function(file, cb){
			if(processed.includes(file.name)) {
				file.name = file.name.slice(0, -4);
				file.name = `${file.name}-${count}.png`
				count++;
			}
			ImageProcessor.createBlob(file.canvas, function(blob){
				processed.push(file.name);
				zip.file(file.name, blob);
				console.log(file.name)
				cb();
			})
		}, function(e){
			if(e) return console.log(e);
			zip.generateAsync({type: "blob"}, function(d){

			})
			.then(function(blob){
				FileSaver.saveAs(blob, "merchresize.zip");
				cb();
			})
		})
}

	static drawAndSavePreLoad(files,type, done){
		let objects = [];
		async.each(files, function(file, cb) {
			ImageProcessor.drawAndSave(file.preview, file.color, file.name, type, function(name, canvas){
				objects.push({name, canvas});
				cb()
			});
		}, function(e){
			if(e) return console.log(e);
			ImageProcessor.downloadAll(objects, function(){
				done();
			})
		})
	}

	static drawAndSave(src, color, name, type, multiple){
		let settings;
		if(type === "Hoodie") {
			settings = {
					w: 4500,
					h: 4050,
					newW: 4500,
					newH: 4050,
				}
		}
		if(type === "T-Shirt") {
			settings = {
					w: 4500,
					h: 5400,
					newW: 4500,
					newH: 5400,
				}
		}
		if(type === "Tote") {
			settings = {
				w: 2925,
				h: 2925,
				newW: 2200,
				newH: 2200,
			}
		}
		if(type === "PopSocket") {
			settings = {
					w: 485,
					h: 485,
					newW: 310,
					newH: 310,
				}
		}
		if(type === "iPhone") {
			settings = {
				w: 1800,
				h: 3200,
				newW: 1101,
				newH: 1753,
			}
		}
		if(type === "Samsung") {
			settings = {
				w: 1800,
				h: 3200,
				newW: 1101,
				newH: 1458,
			}
		}

		const realImage = new Image();
		realImage.onload = () => {
			const canvas = document.createElement("canvas");
			const ctx = canvas.getContext("2d");
			const canvasResized = document.createElement("canvas");

			const trimmed = ImageProcessor.trimCanvas(realImage);
			if(type === "Hoodie" || type === "T-Shirt") {
					ImageProcessor.resizeCanvasImage(trimmed, canvasResized, trimmedWidth, (trimmedHeight > settings.newH) ? settings.newH : trimmedHeight);
			} else {
				ImageProcessor.resizeCanvasImage(trimmed, canvasResized, settings.newW, settings.newH);
			}


			canvas.width = settings.w;
			canvas.height = settings.h;
			if(type === "PopSocket" || type === "Tote" || type === 'iPhone' || type === 'Samsung') {
				ctx.fillStyle = color;
				ctx.fillRect(0, 0, settings.w, settings.h);
			}

			const startXImage = Math.round((settings.w - canvasResized.width)/2);
			let startYImage;

			if(type === 'iPhone') {
				startYImage = 898;
			} else if(type === 'Samsung') {
				startYImage = 1238;
			} else {
				startYImage = Math.round((settings.h - canvasResized.height)/2);
			}

			ctx.drawImage(canvasResized, startXImage, startYImage, canvasResized.width, canvasResized.height);

			let tname = `${name}.png`;
			if(multiple) {
				return multiple(tname, canvas)
			}
			ImageProcessor.download(tname, canvas);
		};
		realImage.src = src;
	}

	static resizeCanvasImage(img, canvas, maxWidth, maxHeight) {
		let imgWidth = img.width,
			imgHeight = img.height;

		let ratio = 1, ratio1 = 1, ratio2 = 1;
		ratio1 = maxWidth / imgWidth;
		ratio2 = maxHeight / imgHeight;

		// Use the smallest ratio that the image best fit into the maxWidth x maxHeight box.
		if (ratio1 < ratio2) {
			ratio = ratio1;
		}
		else {
			ratio = ratio2;
		}

		const canvasContext = canvas.getContext("2d");
		const canvasCopy = document.createElement("canvas");
		const copyContext = canvasCopy.getContext("2d");
		const canvasCopy2 = document.createElement("canvas");
		const copyContext2 = canvasCopy2.getContext("2d");
		canvasCopy.width = imgWidth;
		canvasCopy.height = imgHeight;
		copyContext.drawImage(img, 0, 0);

		// init
		canvasCopy2.width = imgWidth;
		canvasCopy2.height = imgHeight;
		copyContext2.drawImage(canvasCopy, 0, 0, canvasCopy.width, canvasCopy.height, 0, 0, canvasCopy2.width, canvasCopy2.height);

		const rounds = 2;
		const roundRatio = ratio * rounds;
		for (let i = 1; i <= rounds; i++) {
			canvasCopy.width = imgWidth * roundRatio / i;
			canvasCopy.height = imgHeight * roundRatio / i;
			copyContext.drawImage(canvasCopy2, 0, 0, canvasCopy2.width, canvasCopy2.height, 0, 0, canvasCopy.width, canvasCopy.height);
			canvasCopy2.width = imgWidth * roundRatio / i;
			canvasCopy2.height = imgHeight * roundRatio / i;
			copyContext2.drawImage(canvasCopy, 0, 0, canvasCopy.width, canvasCopy.height, 0, 0, canvasCopy2.width, canvasCopy2.height);

		}
		canvas.width = imgWidth * roundRatio / rounds;
		canvas.height = imgHeight * roundRatio / rounds;
		canvasContext.drawImage(canvasCopy2, 0, 0, canvasCopy2.width, canvasCopy2.height, 0, 0, canvas.width, canvas.height);

	}

}



// WEBPACK FOOTER //
// ./src/utils/ImageProcessing.js